import React, { useCallback, useState } from 'react'
import { getInsightContentTypeDisplayText } from 'components/insightContent/utils/utils'
import { Theme } from 'features/ui/types'
import { useDisplayTheme } from 'hooks/useUiState'
// @ts-ignore
import { Tooltip, Dialog } from '@netbasequid/core'
import AccordionSectionType from 'components/insightContent/enum/AccordionSectionType'
import { InsightContentSettingType } from 'components/insightContent/types'
import AccordionGroup from 'components/insightContent/visualization/AccordionGroup'
import InsightContentType from 'components/insightContent/enum/InsightContentType'
import { MetricTimeUnitStrings } from 'enums/MetricTimeUnit'
import { sendTypedMessage } from 'utils/iframeUtil'
import { toExternal } from 'vo/util'
import {
  TopInfoBox,
  TopInfoRight,
  StyledTermContainer,
  StyledTermContent
} from 'components/insightContent/visualization/InfoBox/index.css'
import GoToAnalysisButton from 'components/insightContent/visualization/GoToAnalysisButton'
import InsightDialog from 'components/insightContent/visualization/InsightDialog'
import { PostMetricWithSoundbites } from '../../types'

const DIALOG_CONTENT_HEIGHT = '460px'

const InsightModal = ({
  open,
  title,
  selectedInsight,
  onClose,
  detailSetting,
  timeUnits,
  forceNotScale,
  widgetSettingWithSelection
}: {
  open: boolean
  title: string | undefined
  selectedInsight: PostMetricWithSoundbites | undefined
  onClose: () => void
  detailSetting: InsightContentSettingType | undefined
  timeUnits?: MetricTimeUnitStrings[]
  forceNotScale?: boolean
  widgetSettingWithSelection?: any
}) => {
  const theme = useDisplayTheme() as Theme
  const [displayTooltip, setDisplayTooltip] = useState(false)

  const checkTermContent = useCallback((node: HTMLDivElement) => {
    if (!node) return

    setDisplayTooltip(node.scrollHeight! > node.clientHeight!)
  }, [])

  function goToAnalysis() {
    sendTypedMessage('goToAnalysis', toExternal(widgetSettingWithSelection))
  }

  return (
    <InsightDialog open={open} onClose={onClose}>
      <Dialog.DialogTitle>{title}</Dialog.DialogTitle>
      <TopInfoBox mode={theme}>
        <StyledTermContainer ref={checkTermContent}>
          <Tooltip
            mode={theme}
            enabled={displayTooltip}
            content={selectedInsight?.mentionedUrls?.[0]?.url}>
            <StyledTermContent mode={theme}>
              {selectedInsight?.mentionedUrls?.[0]?.url}
            </StyledTermContent>
          </Tooltip>
        </StyledTermContainer>
        <TopInfoRight>
          <GoToAnalysisButton onClick={() => goToAnalysis()} />
        </TopInfoRight>
      </TopInfoBox>
      <Dialog.DialogContent height={DIALOG_CONTENT_HEIGHT}>
        <AccordionGroup
          timeUnits={timeUnits}
          forceNotScale={forceNotScale}
          insightContentsConfig={[
            {
              accordionTitle: getInsightContentTypeDisplayText(AccordionSectionType.TOP_AUTHOR),
              accordionContents: [
                {
                  insightContentType: InsightContentType.MENTIONS,
                  detailSetting
                }
              ]
            }
          ]}
        />
      </Dialog.DialogContent>
      <Dialog.DialogActions />
    </InsightDialog>
  )
}

export default InsightModal
